// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { History, Match } from 'react-router-dom';
import { defineMessages, injectIntl, IntlContext } from 'react-intl';
import * as sidePanelActions from 'esm-web-pro/redux/side-panel/actions';
import type { SidePanel } from 'esm-web-pro/redux/side-panel/reducer';
import { getSidePanel } from 'esm-web-pro/redux/side-panel';


const msg = defineMessages({
    blockMessage: {
        id: 'network-draw-block-message',
        defaultMessage: 'The drawing will stop and already drawn items will not be saved',
    },
});

type SidePanelStoreProps = {
    sidePanel: ?SidePanel,
}

type SidePanelActionProps = {
    openPanel: (key: string, url: ?string, sensitive?: boolean | { message: string }) => {
        key: string, url: string, skipSensitivity: boolean
    },
    setSensitivity: (key: string, sensitivity: boolean) => void,
}

type Props = {
    ...$Exact<SidePanelStoreProps>,
    ...$Exact<SidePanelActionProps>,
    children: (onClose: Function) => React.Node,
    id: string,
    map: Object,
    url: string,
    history: History,
    match: Match,
    intl: IntlContext,
}

const mapStateToProps = (state, ownProps) => ({
    sidePanel: (() => getSidePanel(state, ownProps.id))(),
});

const mapDispatchToProps = (dispatch) => (
    bindActionCreators(sidePanelActions, dispatch)
);

const CreatorContainer = (props: Props) => {
    const {
        children, id, openPanel, history, match, url, setSensitivity,
        intl: { formatMessage },
    } = props;

    React.useEffect(() => {
        openPanel(id, '', url, { message: formatMessage(msg.blockMessage) });
    }, [id, url, formatMessage, openPanel]);

    const handleClose = (skip: boolean) => {
        if (skip) {
            setSensitivity(id, false);
        }
        history.push(`${match.url.split('/draw')[0]}`);
    };

    return children(handleClose);
};

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CreatorContainer)));
